import {
  newCardValidators,
  validateBlurredField,
} from "helpers/validation/forms";
import VALIDATION_MESSAGES from "helpers/validation/messages";
import type { INewCreditCard } from "types/reducers/payment";

export const DELETE_LOCAL_CARD_RECORD = "credit_cards/DELETE_LOCAL_CARD_RECORD";
export const RECEIVE_CREDIT_CARD = "credit_cards/RECEIVE_CREDIT_CARD";
export const VALIDATE_CC_FIELD_ON_BLUR =
  "credit_cards/VALIDATE_CC_FIELD_ON_BLUR";
export const SET_CREDIT_CARD_ERROR_MESSAGES =
  "credit_cards/SET_CREDIT_CARD_ERROR_MESSAGES";

function validateCCFieldOnBlur(field: string, card: INewCreditCard) {
  const error = validateBlurredField(
    field,
    card,
    newCardValidators,
    VALIDATION_MESSAGES
  );

  return {
    type: VALIDATE_CC_FIELD_ON_BLUR,
    error,
    field,
    card,
  };
}

export function setCreditCardValidationMessages(error) {
  return {
    type: SET_CREDIT_CARD_ERROR_MESSAGES,
    error,
  };
}

export { validateCCFieldOnBlur };
